import { render, staticRenderFns } from "./RNumReviewsFilter.vue?vue&type=template&id=18f37adc&scoped=true&"
import script from "./RNumReviewsFilter.vue?vue&type=script&lang=js&"
export * from "./RNumReviewsFilter.vue?vue&type=script&lang=js&"
import style0 from "./RNumReviewsFilter.vue?vue&type=style&index=0&id=18f37adc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f37adc",
  null
  
)

export default component.exports